import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PublicNav from '../components/PublicNav';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen pb-24 md:pb-0" style={{ backgroundColor: '#F5F0E6' }}>
      <Helmet>
        <title>Terms of Service | Survivor Fantasy League</title>
        <meta name="description" content="Terms of Service for Survivor Fantasy League." />
        <link rel="canonical" href="https://survivorfantasy.live/terms" />
      </Helmet>

      <PublicNav />

      {/* Content */}
      <article className="py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-2" style={{ color: '#1E3A4C', fontFamily: "'Playfair Display', serif" }}>
            Terms of Service
          </h1>
          <p className="text-sm mb-8" style={{ color: '#4682B4' }}>
            Effective Date: April 2026
          </p>

          <div className="prose prose-lg max-w-none" style={{ color: '#4682B4', lineHeight: '1.8' }}>
            <p>
              Welcome to Survivor Fantasy League. By accessing or using our website at survivorfantasy.live (the "Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the Service.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>1. Description of Service</h2>
            <p>
              Survivor Fantasy League is a free fantasy sports platform that allows users to create fantasy leagues based on the CBS television show Survivor. Users can draft contestants, earn points based on show events, and compete against other players.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>2. Eligibility</h2>
            <p>
              You must be at least 13 years old to use this Service. By using the Service, you represent that you meet this requirement.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>3. Account Registration</h2>
            <p>
              To access certain features, you must create an account. You agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Accept responsibility for all activity under your account</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>4. User Conduct</h2>
            <p>When using the Service, you agree NOT to:</p>
            <ul>
              <li>Violate any applicable laws or regulations</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Post offensive, defamatory, or inappropriate content</li>
              <li>Attempt to gain unauthorized access to the Service</li>
              <li>Use automated systems to access the Service without permission</li>
              <li>Interfere with the proper functioning of the Service</li>
              <li>Impersonate others or misrepresent your identity</li>
              <li>Use the Service for any illegal purpose</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>5. Fantasy Leagues and Scoring</h2>
            <p>
              Survivor Fantasy League is for entertainment purposes only. We make no guarantees about:
            </p>
            <ul>
              <li>The accuracy of scoring or point calculations</li>
              <li>The availability of any features or functionality</li>
              <li>The outcome of any fantasy competition</li>
            </ul>
            <p>
              League Admins are responsible for managing their leagues and scoring events accurately. We are not liable for disputes between league members.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>6. Free Service; No Guarantees</h2>
            <p>
              The Service is provided free of charge. We do not guarantee:
            </p>
            <ul>
              <li>Continuous, uninterrupted availability</li>
              <li>Error-free operation</li>
              <li>That the Service will meet your expectations</li>
              <li>Data preservation or backup</li>
            </ul>
            <p>
              We reserve the right to modify, suspend, or discontinue any part of the Service at any time without notice.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>7. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account at any time, for any reason, including but not limited to:
            </p>
            <ul>
              <li>Violation of these Terms</li>
              <li>Abusive or harmful behavior</li>
              <li>Fraudulent activity</li>
              <li>Extended periods of inactivity</li>
            </ul>
            <p>
              You may delete your account at any time by contacting us.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>8. Intellectual Property</h2>
            <p>
              The Service and its original content (excluding user-generated content) are owned by Survivor Fantasy League and are protected by copyright and other laws.
            </p>
            <p>
              "Survivor" is a registered trademark of CBS. Survivor Fantasy League is not affiliated with, endorsed by, or sponsored by CBS, Survivor Productions LLC, or any related entities.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>9. Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>10. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, SURVIVOR FANTASY LEAGUE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Survivor Fantasy League from any claims, damages, or expenses arising from your use of the Service or violation of these Terms.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>12. Governing Law</h2>
            <p>
              These Terms shall be governed by the laws of the United States, without regard to conflict of law principles.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>13. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance of the new Terms.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4" style={{ color: '#1E3A4C' }}>14. Contact</h2>
            <p>
              For questions about these Terms, please contact us at:
            </p>
            <p>
              <a href="mailto:support@survivorfantasy.live" className="text-[#FF7F50] underline">support@survivorfantasy.live</a>
            </p>
          </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="py-12" style={{ backgroundColor: '#1E3A4C' }}>
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <img src="/logo-new.png" alt="Survivor Fantasy League" className="w-10 h-10" />
              <span className="text-white font-bold text-lg">Survivor Fantasy League</span>
            </div>
            
            <div className="flex flex-wrap justify-center gap-6 text-sm" style={{ color: '#F5F0E6' }}>
              <Link to="/" className="hover:text-[#FF7F50] transition-colors">Home</Link>
              <Link to="/rules" className="hover:text-[#FF7F50] transition-colors">Rules</Link>
              <Link to="/faq" className="hover:text-[#FF7F50] transition-colors">FAQ</Link>
              <Link to="/about" className="hover:text-[#FF7F50] transition-colors">About</Link>
              <Link to="/blog" className="hover:text-[#FF7F50] transition-colors">Blog</Link>
              <Link to="/privacy" className="hover:text-[#FF7F50] transition-colors">Privacy</Link>
              <Link to="/terms" className="hover:text-[#FF7F50] transition-colors">Terms</Link>
            </div>
          </div>
          
          <div className="border-t mt-8 pt-8 text-center text-sm" style={{ borderColor: '#4682B4', color: '#4682B4' }}>
            <p>© {new Date().getFullYear()} Survivor Fantasy League. Not affiliated with CBS or Survivor.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
